module.exports = __webpack_public_path__ + "img/product-after-sale-solve-bg-icon.1857803e.png";